export default "__VITE_ASSET__CZQ4PG8h__"